module.exports = __webpack_public_path__ + "static/media/top_infographic_mobile.aaf0c2fd.webp";